/*
 * Footer menu columns.
 *
 * Each column is a native <details>: on a phone it is a tap-to-expand
 * accordion, which is exactly what we want and works with no script at all.
 * From 750px up the columns should simply be lists, so this file holds them
 * open above that width and lets them collapse again below it.
 *
 * Written as a plain listener rather than a custom element because it governs
 * a set of elements, not one — there is nothing for an element to wrap.
 */
(function () {
  var query = window.matchMedia('(min-width: 750px)');

  function apply(event) {
    var columns = document.querySelectorAll('.footer-accordion');
    for (var i = 0; i < columns.length; i++) {
      if (event.matches) columns[i].setAttribute('open', '');
      else columns[i].removeAttribute('open');
    }
  }

  function start() {
    apply(query);
    query.addEventListener('change', apply);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
